module.exports = __webpack_public_path__ + "static/media/message.c4a519e5.svg";